"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const react_1 = require("react");
/**
 * @function useOnClickOutside - validates the clicks outside the ref
 * @param {function} ref - the ref element we should listen to
 * @param {callback} handler
 * @returns {callback}
 */
const useOnClickOutside = (ref, handler) => {
    react_1.useEffect(() => {
        const listener = event => {
            if (!ref.current || ref.current.contains(event.target))
                return;
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};
exports.useOnClickOutside = useOnClickOutside;
exports.default = exports.useOnClickOutside;
//# sourceMappingURL=index.js.map